module.exports.publicPath = '/'

/**
 * Google Pay & Wallet Console 档案（merchantInfo）。
 * - botimMoney：PSP 线（我方自行解密 MERCHANT_DECRYPT）的兜底档案，正常由后端
 *   payMethodExtension.googleMerchantId / googleMerchantName 下发；
 * - payBy：老网关解密链路继续使用。
 * 换档案只改这里，不要散落在业务代码里。
 */
module.exports.googlePayMerchantProfiles = {
  botimMoney: { merchantId: 'BCR2DN6DTLJ67ORT', merchantName: 'Botim Money' },
  payBy: { merchantId: 'BCR2DN4TQDO55DC5', merchantName: 'PayBy' },
}
